export default __webpack_public_path__ + "img/20901661c081faee7263f3ad383c94f1.svg";